import { createFileRoute } from "@tanstack/react-router";

import { allMyApplicationsQueryOptions } from "@/features/applications/queries";
import { allMyBookmarksQueryOptions } from "@/features/bookmarks/queries";
import { MemberCompanyDetailPage } from "@/features/companies/company-detail-page";
import { companyDetailQueryOptions } from "@/features/companies/queries";
import { companyNameCrumb } from "@/lib/crumb-resolvers";

// ロールガードは親 layout (`member/route.tsx`) が MEMBER 限定。
export const Route = createFileRoute("/_authenticated/member/companies/$id/")({
  staticData: { crumb: companyNameCrumb() },
  loader: async ({ context, params }) => {
    // 案件カードの「応募済み」「保存済み」バッジ判定に使う自分の応募・保存も並行で先読みする
    // （page 側は useSuspenseQuery なので、先読みしないと企業詳細の後に直列で取りに行く）。
    await Promise.all([
      context.queryClient.ensureQueryData(companyDetailQueryOptions(params.id)),
      context.queryClient.ensureQueryData(allMyApplicationsQueryOptions()),
      context.queryClient.ensureQueryData(allMyBookmarksQueryOptions()),
    ]);
  },
  component: MemberCompanyDetailPage,
});
